import Head from 'next/head';
import { FC } from 'react';
import { IMeta } from './Meta.type';

const thumbnailUrl =
	process.env.SENTRY_BUILD_ENV === 'preprod'
		? 'https://preprod.nodeguardians.com/thumbnail.webp'
		: process.env.BUILD_ENV === 'production'
		? 'https://nodeguardians.io/thumbnail.webp'
		: 'https://staging.nodeguardians.com/thumbnail.webp';

const defaultDescription = 'Level up your code';

// used to add title and meta tags to the page
const Meta: FC<IMeta> = ({ title, description, metas, thumbnailSrc, children }) => (
	<Head>
		<title>{title}</title>
		<meta property='og:title' content={title} key='title' />

		<meta property='og:title' content={title} key='title' />

		<meta name='description' content={description || defaultDescription} />
		<meta property='og:description' content={description || defaultDescription} />

		<meta property='og:image' content={thumbnailSrc || thumbnailUrl} />

		<meta name='twitter:card' content='summary' />
		<meta name='twitter:site' content='@nodeguardians' />
		<meta name='twitter:creator	' content='@nodeguardians' />
		<meta name='twitter:title' content={title} />
		<meta name='twitter:description' content={description || defaultDescription} />
		<meta name='twitter:image' content={thumbnailSrc || thumbnailUrl} />
		<meta name='twitter:image:alt' content='Nodeguardians' />

		{metas?.map(({ name, content }) => (
			<meta key={name} name={name} content={content} />
		))}

		{children}
	</Head>
);

export { Meta };
